import { CoLenderFinancierByIdRequest, CoLenderFinancierFetchRequest, CoLenderFinancierReduxTypes, CreateCoLenderFinancierRequest, UpdateCoLenderFinancierRequest } from "./types";
import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";
import { approveCoLenderFinancierApi, blockCoLenderFinancierApi, createCoLenderFinancierApi, deleteCoLenderFinancierApi, fetchCoLenderFinancierByIdApi, fetchCoLenderFinancierLatestVersionApi, fetchCoLenderFinanciersApi, fetchCoLenderFinancierVersionDetailsApi, fetchCoLenderFinancierVersionsApi, freezeCoLenderFinancierApi, rejectCoLenderFinancierApi, unfreezeCoLenderFinancierApi, updateCoLenderFinancierApi } from "./api";

function* fetchCoLenderFinanciers({ payload }: CoLenderFinancierFetchRequest): SagaIterator {
    try {
        const response = yield call(fetchCoLenderFinanciersApi, payload);
        yield put({
            type: CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIERS_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIERS_ERROR,
            payload: { error: error }
        });
    }
}

function* fetchCoLenderFinancierById({ payload }: CoLenderFinancierByIdRequest): SagaIterator {
    try {
        const response = yield call(fetchCoLenderFinancierByIdApi, payload);
        yield put({
            type: CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_BY_ID_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_BY_ID_ERROR,
            payload: { error: error }
        });
    }
}

function* createCoLenderFinancier({ payload }: CreateCoLenderFinancierRequest): SagaIterator {
    try {
        const response = yield call(createCoLenderFinancierApi, payload);
        yield put({
            type: CoLenderFinancierReduxTypes.CREATE_CO_LENDER_FINANCIER_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: CoLenderFinancierReduxTypes.CREATE_CO_LENDER_FINANCIER_ERROR,
            payload: { error: error }
        });
    }
}

function* updateCoLenderFinancier({ payload }: UpdateCoLenderFinancierRequest): SagaIterator {
    try {
        const response = yield call(updateCoLenderFinancierApi, payload);
        yield put({
            type: CoLenderFinancierReduxTypes.UPDATE_CO_LENDER_FINANCIER_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: CoLenderFinancierReduxTypes.UPDATE_CO_LENDER_FINANCIER_ERROR,
            payload: { error: error }
        });
    }
}

function* deleteCoLenderFinancier({ payload }: UpdateCoLenderFinancierRequest): SagaIterator {

    try {
        const response = yield call(deleteCoLenderFinancierApi, payload);
        yield put({
            type: CoLenderFinancierReduxTypes.DELETE_CO_LENDER_FINANCIER_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: CoLenderFinancierReduxTypes.DELETE_CO_LENDER_FINANCIER_ERROR,
            payload: { error: error }
        });
    }
}

function* fetchCoLenderFinancierVersions({ payload }: UpdateCoLenderFinancierRequest): SagaIterator {
    try {
        const response = yield call(fetchCoLenderFinancierVersionsApi, payload);
        yield put({
            type: CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_VERSIONS_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_VERSIONS_ERROR,
            payload: { error: error }
        });
    }
}

function* fetchCoLenderFinancierVersionDetails({ payload }: UpdateCoLenderFinancierRequest): SagaIterator {
    try {
        const response = yield call(fetchCoLenderFinancierVersionDetailsApi, payload);
        yield put({
            type: CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_VERSIONS_DETAILS_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_VERSIONS_DETAILS_ERROR,
            payload: { error: error }
        });
    }
}

function* fetchCoLenderFinancierLatestVersion({ payload }: UpdateCoLenderFinancierRequest): SagaIterator {
    try {
        const response = yield call(fetchCoLenderFinancierLatestVersionApi, payload);
        yield put({
            type: CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_LATEST_VERSIONS_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_LATEST_VERSIONS_ERROR,
            payload: { error: error }
        });
    }
}
function* blockCoLenderFinancier({payload}: UpdateCoLenderFinancierRequest): SagaIterator {
    try {
        const response = yield call(blockCoLenderFinancierApi, payload);
        yield put({
            type: CoLenderFinancierReduxTypes.BLOCK_CO_LENDER_FINANCIER_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: CoLenderFinancierReduxTypes.BLOCK_CO_LENDER_FINANCIER_ERROR,
            payload: { error: error }
        });
    }
}

function* approveCoLenderFinancier({payload}: UpdateCoLenderFinancierRequest): SagaIterator {
    try {
        const response = yield call(approveCoLenderFinancierApi, payload);
        yield put({
            type: CoLenderFinancierReduxTypes.APPROVE_CO_LENDER_FINANCIER_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: CoLenderFinancierReduxTypes.APPROVE_CO_LENDER_FINANCIER_ERROR,
            payload: { error: error }
        });
    }
}

function* rejectCoLenderFinancier({payload}: UpdateCoLenderFinancierRequest): SagaIterator {
    try {
        const response = yield call(rejectCoLenderFinancierApi, payload);
        yield put({
            type: CoLenderFinancierReduxTypes.REJECT_CO_LENDER_FINANCIER_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: CoLenderFinancierReduxTypes.REJECT_CO_LENDER_FINANCIER_ERROR,
            payload: { error: error }
        });
    }
}

function* freezeCoLenderFinancier({payload}: UpdateCoLenderFinancierRequest): SagaIterator {
    try {
        const response = yield call(freezeCoLenderFinancierApi, payload);
        yield put({
            type: CoLenderFinancierReduxTypes.FREEZE_CO_LENDER_FINANCIER_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: CoLenderFinancierReduxTypes.FREEZE_CO_LENDER_FINANCIER_ERROR,
            payload: { error: error }
        });
    }
}

function* unfreezeCoLenderFinancier({payload}: UpdateCoLenderFinancierRequest): SagaIterator {
    try {
        const response = yield call(unfreezeCoLenderFinancierApi, payload);
        yield put({
            type: CoLenderFinancierReduxTypes.UNFREEZE_CO_LENDER_FINANCIER_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: CoLenderFinancierReduxTypes.UNFREEZE_CO_LENDER_FINANCIER_ERROR,
            payload: { error: error }
        });
    }
}

export function* watchFetchCoLenderFinanciers(): SagaIterator {
    yield takeEvery(CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIERS, fetchCoLenderFinanciers);
}

export function* watchFetchCoLenderFinancierById(): SagaIterator {
    yield takeEvery(CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_BY_ID, fetchCoLenderFinancierById);
}

export function* watchCreateCoLenderFinancier(): SagaIterator {
    yield takeEvery(CoLenderFinancierReduxTypes.CREATE_CO_LENDER_FINANCIER, createCoLenderFinancier);
}

export function* watchUpdateCoLenderFinancier(): SagaIterator {
    yield takeEvery(CoLenderFinancierReduxTypes.UPDATE_CO_LENDER_FINANCIER, updateCoLenderFinancier);
}

export function* watchDeleteCoLenderFinancier(): SagaIterator {
    yield takeEvery(CoLenderFinancierReduxTypes.DELETE_CO_LENDER_FINANCIER, deleteCoLenderFinancier);
}

export function* watchFetchCoLenderFinancierVersions(): SagaIterator {
    yield takeEvery(CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_VERSIONS, fetchCoLenderFinancierVersions);
}

export function* watchFetchCoLenderFinancierVersionDetails(): SagaIterator {
    yield takeEvery(CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_VERSIONS_DETAILS, fetchCoLenderFinancierVersionDetails);
}

export function* watchFetchCoLenderFinancierLatestVersion(): SagaIterator {
    yield takeEvery(CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_LATEST_VERSIONS, fetchCoLenderFinancierLatestVersion);
}
export function* watchBlockCoLenderFinancier():SagaIterator {
    yield takeEvery(CoLenderFinancierReduxTypes.BLOCK_CO_LENDER_FINANCIER,blockCoLenderFinancier)
}
export function* watchApproveCoLenderFinancier():SagaIterator {
    yield takeEvery(CoLenderFinancierReduxTypes.APPROVE_CO_LENDER_FINANCIER,approveCoLenderFinancier)
}
export function* watchRejectCoLenderFinancier():SagaIterator {
    yield takeEvery(CoLenderFinancierReduxTypes.REJECT_CO_LENDER_FINANCIER,rejectCoLenderFinancier)
}
export function* watchFreezeCoLenderFinancier():SagaIterator {
    yield takeEvery(CoLenderFinancierReduxTypes.FREEZE_CO_LENDER_FINANCIER,freezeCoLenderFinancier)
}
export function* watchUnfreezeCoLenderFinancier():SagaIterator {
    yield takeEvery(CoLenderFinancierReduxTypes.UNFREEZE_CO_LENDER_FINANCIER,unfreezeCoLenderFinancier)
}
function* coLenderFinancierSaga(): SagaIterator {
    yield all([
        fork(watchFetchCoLenderFinanciers),
        fork(watchFetchCoLenderFinancierById),
        fork(watchCreateCoLenderFinancier),
        fork(watchUpdateCoLenderFinancier),
        fork(watchDeleteCoLenderFinancier),
        fork(watchFetchCoLenderFinancierVersions),
        fork(watchFetchCoLenderFinancierVersionDetails),
        fork(watchFetchCoLenderFinancierLatestVersion),
        fork(watchBlockCoLenderFinancier),
        fork(watchApproveCoLenderFinancier),
        fork(watchRejectCoLenderFinancier),
        fork(watchFreezeCoLenderFinancier),
        fork(watchUnfreezeCoLenderFinancier)
    ]);
}

export default coLenderFinancierSaga;